export enum SettingsReportType {
	"REPORT_TYPE" = "REPORT_TYPE",
	"REPORT_POS_SETTLEMENT" = "REPORT_POS_SETTLEMENT",
	"REPORT_AUTO_START_AMOUNT" = "REPORT_AUTO_START_AMOUNT",
	"REPORT_REMOVES_BILLS_AFTER_OPEN" = "REPORT_REMOVES_BILLS_AFTER_OPEN",
}

export enum SettingsSaleOpenType {
	"SALE_DEFAULT_BUTTON" = "SALE_DEFAULT_BUTTON",
	"SALE_BILL_TYPE_BUTTON" = "SALE_BILL_TYPE_BUTTON",
	"SALE_QUICK_BUTTON" = "SALE_QUICK_BUTTON",
	"SALE_CLIENT_BUTTON" = "SALE_CLIENT_BUTTON",
	"SALE_COMMENT_BUTTON" = "SALE_COMMENT_BUTTON",
	"SALE_GROUP_BUTTON" = "SALE_GROUP_BUTTON",
	"SALE_GUEST_NUMBER_POPUP" = "SALE_GUEST_NUMBER_POPUP",
}

export enum SettingsSaleEditType {
	"SALE_GUEST_NUMBER_BUTTON" = "SALE_GUEST_NUMBER_BUTTON",
	"SALE_SEAT" = "SALE_SEAT",
	"SALE_CLIENT_OPTION" = "SALE_CLIENT_OPTION",
	"SALE_CLIENT_CARD_OPTION" = "SALE_CLIENT_CARD_OPTION",
	"SALE_TABLE_OPTION" = "SALE_TABLE_OPTION",
	"SALE_OPEN_CASH_DRAWER" = "SALE_OPEN_CASH_DRAWER",
	"SALE_DESCRIPTION_OPTION" = "SALE_DESCRIPTION_OPTION",
	"SALE_SPLIT_OPTION" = "SALE_SPLIT_OPTION",
	"SALE_PRINT_INITIAL_OPTION" = "SALE_PRINT_INITIAL_OPTION",
	"SALE_RESEND_TO_KITCHEN" = "SALE_RESEND_TO_KITCHEN",
	"SALE_DETERMINED_PRICE_OPTION" = "SALE_DETERMINED_PRICE_OPTION",
	"SALE_CLIENT_BARCODE_OPTION" = "SALE_CLIENT_BARCODE_OPTION",
	"SALE_MENU_GRID_OPTION" = "SALE_MENU_GRID_OPTION",
	"SALE_MENU_SEARCH_OPTION" = "SALE_MENU_SEARCH_OPTION",
	"SALE_MENU_SKU_OPTION" = "SALE_MENU_SKU_OPTION",
	"SALE_VALIDATE_ORDER_TYPE" = "SALE_VALIDATE_ORDER_TYPE",
	"MENU_DISPLAY_TRANSLATIONS" = "MENU_DISPLAY_TRANSLATIONS",
}

export enum SettingsOtherSaleType {
	"SALE_OPEN_BILLS" = "SALE_OPEN_BILLS",
	"SALE_NOT_AVAILABLE_PRODUCTS" = "SALE_NOT_AVAILABLE_PRODUCTS",
	"SALE_SAVE_ON_CLOSE" = "SALE_SAVE_ON_CLOSE",
	"SALE_STORNO_REASON" = "SALE_STORNO_REASON",
	"SALE_TAX_ID_NO" = "SALE_TAX_ID_NO",
	"SALE_AUTO_RELEASE" = "SALE_AUTO_RELEASE",
	"SCANNER_TYPE" = "SCANNER_TYPE",
	"TRANSFER_SAFE_MODE" = "TRANSFER_SAFE_MODE",
	"SALE_LOGOUT_AFTER_CLOSE_BILL" = "SALE_LOGOUT_AFTER_CLOSE_BILL",
	"SALE_ORDER_ITEM_COURSE_HEADER" = "SALE_ORDER_ITEM_COURSE_HEADER",
	"SALE_FORCE_ORDER_FISCALIZATION" = "SALE_FORCE_ORDER_FISCALIZATION",
	"PRICE_LIST_COMPATIBILITY_MODE" = "PRICE_LIST_COMPATIBILITY_MODE",
	"MODIFIER_GROUPS_EXPAND_TYPE" = "MODIFIER_GROUPS_EXPAND_TYPE",
	"FORCE_KEEP_SCREEN_ON" = "FORCE_KEEP_SCREEN_ON",
	"MONITOR_BATTERY_LEVEL" = "MONITOR_BATTERY_LEVEL",
}

export enum SettingsPaymentsAndReceiptsType {
	"SALE_PRINT_PAYMENT_TERMINAL_CONFIRMATION" = "SALE_PRINT_PAYMENT_TERMINAL_CONFIRMATION",
	"RECEIPT_EMAIL" = "RECEIPT_EMAIL",
	"RECEIPT_SMS" = "RECEIPT_SMS",
	"RECEIPT_QR_CODE" = "RECEIPT_QR_CODE",
	"RECEIPT_PRINTOUT" = "RECEIPT_PRINTOUT",
}

export enum SettingsPreparationStatusesType {
	"KDS_MERGE_ITEMS" = "KDS_MERGE_ITEMS",
	"SALE_STATUS_PREPERATION_DEFAULT" = "SALE_STATUS_PREPERATION_DEFAULT",
	"SALE_BILL_SET_STATUS_PREPARATION" = "SALE_BILL_SET_STATUS_PREPARATION",
	"NOTIFICATION_STATUS_PREPERATION" = "NOTIFICATION_STATUS_PREPERATION",
	"KDS_NUMBER_ENABLED" = "KDS_NUMBER_ENABLED",
}

export enum SettingsStockType {
	"STOCK_TRACKING" = "STOCK_TRACKING",
	"SALE_EMPTY_STOCK" = "SALE_EMPTY_STOCK",
}

export enum SettingsPrintoutType {
	"DIRECTION_PRINTOUT_ID" = "DIRECTION_PRINTOUT_ID",
	"KITCHEN_ORDER_PRINTING_TRIGGER_TYPE" = "KITCHEN_ORDER_PRINTING_TRIGGER_TYPE",
}

export enum SettingsDriversType {
	"IS_LOCATION_REQUIRED" = "IS_LOCATION_REQUIRED",
	"DRIVER_CAN_CHANGE_STATUS_FROM_STATUS" = "DRIVER_CAN_CHANGE_STATUS_FROM_STATUS",
	"DRIVER_CAN_CHANGE_STATUS_TO_DELIVERED_FROM_METERS" = "DRIVER_CAN_CHANGE_STATUS_TO_DELIVERED_FROM_METERS",
	"CITY_SEARCH_DISTANCE_KM" = "CITY_SEARCH_DISTANCE_KM",
	"SALE_VALIDATE_DELIVERY_EMPLOYEE" = "SALE_VALIDATE_DELIVERY_EMPLOYEE",
	"DRIVER_CAN_ASSIGN_ITSELF" = "DRIVER_CAN_ASSIGN_ITSELF",
}

export enum SettingsOtherType {
	"USER_LOGOUT_THRESHOLD" = "USER_LOGOUT_THRESHOLD",
	"RESERVATION" = "RESERVATION",
	"SALE_DISPLAY_STOCK" = "SALE_DISPLAY_STOCK",
	"KDS_FLASH_SECONDS" = "KDS_FLASH_SECONDS",
	"SALE_QUICK_SET_ADD" = "SALE_QUICK_SET_ADD",
	"PRINT_COMPANY_ON_PDF" = "PRINT_COMPANY_ON_PDF",
}

export enum SettingsNumberType {
	"DRIVER_CAN_CHANGE_STATUS_TO_DELIVERED_FROM_METERS" = "DRIVER_CAN_CHANGE_STATUS_TO_DELIVERED_FROM_METERS",
	"CITY_SEARCH_DISTANCE_KM" = "CITY_SEARCH_DISTANCE_KM",
	"USER_LOGOUT_THRESHOLD" = "USER_LOGOUT_THRESHOLD",
	"KDS_FLASH_SECONDS" = "KDS_FLASH_SECONDS",
}

export enum SettingsKioskType {
	"KIOSK_ANIMATION_LIST_ENABLE" = "KIOSK_ANIMATION_LIST_ENABLE",
	"KIOSK_ANIMATION_CHANGE_VIEW_ENABLE" = "KIOSK_ANIMATION_CHANGE_VIEW_ENABLE",
	"KIOSK_BLUR_BACKGROUND_ENABLE" = "KIOSK_BLUR_BACKGROUND_ENABLE",
	"KIOSK_LOW_PERFORMANCE_BLUR_ENABLE" = "KIOSK_LOW_PERFORMANCE_BLUR_ENABLE",
	"KIOSK_CHANGE_CONFIRM_BUTTON_COLOR_ENABLE" = "KIOSK_CHANGE_CONFIRM_BUTTON_COLOR_ENABLE",
}

export enum SettingsBasicKioskType {
	KIOSK_ENABLE = "KIOSK_ENABLE",
	VOUCHER_FEATURE_ENABLED = "VOUCHER_FEATURE_ENABLED",
	ERECEIPT_FEATURE_ENABLED = "ERECEIPT_FEATURE_ENABLED",
	CASH_PAYMENT_FEATURE_ENABLED = "CASH_PAYMENT_FEATURE_ENABLED",
}
